export const SESSION_QUERY_KEY = () => ["session"];
